import React, { useEffect, useState } from "react";
import "./DisplaySuggesition.scss";

const DisplaySuggesition = ({
  dataList,
  customClass,
  onClick,
  inputState,
  visible,
}) => {
  const [displayList, setDisplayList] = useState();

  const getFilteredList = (dataList, inputState) => {
    console.log("enter", dataList, inputState);
    if (inputState === "") {
      return [];
    }
    const filteredData = dataList.filter((data) =>
      data.toLocaleLowerCase().includes(inputState.toLocaleLowerCase())
    );
    return filteredData.length > 0 ? filteredData : ["No results"];
  };

  useEffect(() => {
    console.log("updated", getFilteredList(dataList, inputState));
    setDisplayList(getFilteredList(dataList, inputState));
  }, [inputState]);
  return (
    visible && (
      <div className={"DisplaySuggesition " + customClass}>
        {displayList &&
          displayList?.map((data, index) => {
            return (
              <p
                key={index}
                className={`DisplaySuggesition__data`}
                onClick={() => {
                  onClick && data !== "No results" && onClick(data);
                }}
              >
                {data}
              </p>
            );
          })}
      </div>
    )
  );
};

export default DisplaySuggesition;
